import {
  PhoneIcon,
  LocationIcon,
  EmailIcon,
  FacebookIcon,
  TwitterXIcon,
  InstagramIcon,
  YouTubeIcon,
  PinrestIcon,
} from "@/components/icons/contactus-icon";

// ------- 1 -> values Card Data ------- //
export const contactcontent = [
  {
    icon: <PhoneIcon />,
    title: "Phone No.",
    content: "+91 81412 61261",
    href: "tel:+918141261261",
  },
  {
    icon: <LocationIcon />,
    title: "Location",
    content: "Dhananjay House, Plot No. 85, Chhatrala Ind Park, Near Kadodara Chowkdi, B/h MacDonald, Kadodara, Surat, Gujarat 394325",
    href: "",
  },
  {
    icon: <EmailIcon />,
    title: "Email",
    content: "care@thekalindi.com",
    href: "mailto:care@thekalindi.com",
  },
];

// ------- 2 -> values Card Data ------- //
export const SocialDetail = [
  {
    link: "https://www.facebook.com/kalindiindia",
    icon: <FacebookIcon />,
    title: "facebook",
  },
  // {
  //   link: "",
  //   icon: <TwitterXIcon />,
  // },
  {
    link: "https://www.instagram.com/the_kalindi_label",
    icon: <InstagramIcon />,
    title: "instagream",
  },
  // {
  //   link: "",
  //   icon: <YouTubeIcon />,
  // },
  // {
  //   link: "",
  //   icon: <PinrestIcon />,
  // },
];
